import { render, staticRenderFns } from "./TestCreateOptionsPage.vue?vue&type=template&id=123385e1&scoped=true"
import script from "./TestCreateOptionsPage.vue?vue&type=script&lang=js"
export * from "./TestCreateOptionsPage.vue?vue&type=script&lang=js"
import style0 from "./TestCreateOptionsPage.vue?vue&type=style&index=0&id=123385e1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123385e1",
  null
  
)

export default component.exports